<convfact-mandate-form [mandate]="mandate" *ngIf="mandate" [errors]="errors" (onSave)="saveData($event)">
</convfact-mandate-form>